<template lang="pug">
.transition-slide
  transition(name="slide" v-on:beforeEnter="beforeEnter" v-on:beforeLeave="beforeLeave")
    slot
  
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
export default {
  name: 'TransitionSlide',
  props: {},
  data() {
    return {
      routerTable: {
        '/reservation': 0,
        '/reservation/res1': 1,
        '/reservation/res2': 2,
        '/reservation/res3': 3,
        '/reservation/addAdult': 4,
        '/reservation/addAdult/process': 5,
        '/reservation/res4': 4,
        '/reservation/res5': 5,
        '/me/main': 1,
        '/me/fam': 2,
        '/me/res': 2,
        '/me/footprint': 2,
        '/me/resCancel': 4,
        '/me/resReschedule': 4,
        '/me/resRescheduleProcess': 5,
        '/me/addAdult': 3,
        '/me/addAdult/process': 4,

        '/home': 0,
        '/home/ticketPurchase': 1,
        '/home/warning': 1,
      },
    }
  },
  computed: {
    ...mapState('app', ['router']),
    ...mapGetters('app', ['getReses']),
  },
  watch: {
    getReses(val) {
      let length = val.length
      for (let i = 0; i < length; i++) {
        this.routerTable[`/me/res/${val[i].resId}`] = 3
      }
    },
  },
  methods: {
    beforeEnter(el) {
      console.log('enter!!!!!!!!!', el, this.$route.path, this.router.last)
      let dir =
        this.routerTable[this.$route.path] - this.routerTable[this.router.last]
      if (dir > 0) {
        this.enterFromRight(el)
      } else {
        this.enterFromLeft(el)
      }
    },
    beforeLeave(el) {
      console.log('leave!!!!!!!!', el, this.$route.path)
      let dir =
        this.routerTable[this.$route.path] - this.routerTable[this.router.last]
      if (dir > 0) {
        this.leaveToLeft(el)
      } else {
        this.leaveToRight(el)
      }
    },
    enterFromLeft(el) {
      if (!el.classList.contains('left')) el.classList.add('left')
      if (el.classList.contains('right')) el.classList.remove('right')
    },
    enterFromRight(el) {
      if (el.classList.contains('left')) el.classList.remove('left')
      if (!el.classList.contains('right')) el.classList.add('right')
    },
    leaveToLeft(el) {
      if (!el.classList.contains('left')) el.classList.add('left')
      if (el.classList.contains('right')) el.classList.remove('right')
    },
    leaveToRight(el) {
      if (el.classList.contains('left')) el.classList.remove('left')
      if (!el.classList.contains('right')) el.classList.add('right')
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.slide-enter, .slide-leave-to
  &.left
    transform: translateX(-100%)
  &.right
    transform: translateX(100%)
.slide-enter-active, .slide-leave-active
  transition: all .5s
</style>
